/** @jsx jsx */
import { Box, jsx, ResponsiveStyleValue } from "theme-ui";
import React, { PropsWithChildren } from "react";
import { PrimitiveProps } from "@styles/types";
import {
  BackgroundImageStyles,
  ImageStyles,
  ContentWrapperStyles,
} from "./styles";
import { ImageField } from "../../../../carlsberg-headless/types/fields/Image";
import { UmbracoImage } from "@shared-components/Image/UmbracoImage/UmbracoImage";
import { ImageProcessorParams } from "../../../../carlsberg-headless/image-processor/serialize-query-parameters";

export interface UmbracoBackgroundImageProps extends PrimitiveProps {
  params?: ResponsiveStyleValue<ImageProcessorParams>;
  image: ImageField;
  width?: ResponsiveStyleValue<string | number>;
  height?: ResponsiveStyleValue<string | number>;
  lazyLoadOffset?: number;
  altText?: string;
  className?: string;
}

const UmbracoBackgroundImage: React.FC<
  PropsWithChildren<UmbracoBackgroundImageProps>
> = ({ sx, children, image, ...otherProps }) => {
  if (!image) {
    return null;
  }

  const { altText } = image;

  return (
    <Box sx={{ ...BackgroundImageStyles, ...sx }}>
      <UmbracoImage
        isCover
        alt={altText ?? ""}
        image={image}
        {...otherProps}
        sx={{
          ...ImageStyles,
        }}
      />
      <Box sx={ContentWrapperStyles}>{children}</Box>
    </Box>
  );
};

UmbracoBackgroundImage.defaultProps = {};

export { UmbracoBackgroundImage };
